import React, { memo } from "react";
import clsx from "clsx";
import Text from "../../../../../../../shared-components/css-modules/toyota/atoms/Text";
import styles from "./Overview.module.scss";
import { CarConfigLabel } from "../../../../../../utils/labelUtils";
import { useCarConfigSelector } from "../../../../../../redux/store";
import Price from "../../../../common/price/Price";
import { trackWinterWheelFitting, trackWinterWheelRemoveFromBasket } from "../../../../../../utils/tracking";
import { setWinterWheel } from "../../../../../../redux/slices/CarConfigBasketSlice";
import Button from "../../../../../../../shared-components/css-modules/toyota/atoms/Button";
import { showAccessoriesRate } from "../../../../../../utils/financeInsuranceRate";
import Icon from "../../../../../../../shared-components/css-modules/toyota/atoms/Icon";
import { CarConfigConfigureSection } from "../../../../../../utils/types/SectionTypes";
import OverviewItemWrapper from "./OverviewItemWrapper";
import { getWheelsVisual } from "../../../../../../utils/visualUtils";
import { useDispatch } from "../../../../../../../../../shared-logic/redux/store";

const OverviewWheels = (): JSX.Element => {
    const wheel = useCarConfigSelector((state) => state.basket.wheel);
    const winterWheel = useCarConfigSelector((state) => state.basket.winterWheel);
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const carConfigSettings = useCarConfigSelector((state) => state.carConfigSettings);
    const dispatch = useDispatch();

    const imageWheels = getWheelsVisual(wheel, commonSettings);

    return (
        <OverviewItemWrapper
            title="carConfigOverviewTileWheels"
            editSection={CarConfigConfigureSection.Wheels}
            image={imageWheels}
        >
            <div>
                {winterWheel && (
                    <Text variant="apheleia-body" spacing="spacing-0" className={styles.category}>
                        <CarConfigLabel label="carConfigOverviewTileWheelsSubtitle" />
                    </Text>
                )}
                <ul role="list" className={styles.sublist}>
                    <li className={styles.listitem}>
                        <div>
                            <Text variant="apheleia-body" spacing="spacing-0">
                                {wheel.name}
                            </Text>
                        </div>
                        <div className={styles.listprice}>
                            <Text variant="apheleia-body" spacing="spacing-0">
                                {wheel.standard || wheel.price.cash === 0 ? (
                                    <span className={styles.included}>
                                        <CarConfigLabel label="carConfigIncluded" />
                                        <span className={clsx(styles["included-icon"], styles.small)}>
                                            <Icon variant="check" sizing="xs" aria-hidden="true" />
                                        </span>
                                    </span>
                                ) : (
                                    <span className={styles["listprice-price"]}>
                                        +&nbsp;
                                        <Price
                                            price={wheel.price}
                                            forceCashPrice={!showAccessoriesRate(commonSettings, carConfigSettings)}
                                        />
                                    </span>
                                )}
                            </Text>
                        </div>
                    </li>
                </ul>
                {winterWheel && (
                    <>
                        <Text variant="apheleia-body" spacing="spacing-0" className={styles.category}>
                            <CarConfigLabel label="carConfigOverviewTileWinterWheelsSubtitle" />
                        </Text>
                        <ul role="list" className={styles.sublist}>
                            <li className={styles.listitem}>
                                <div>
                                    <Text variant="apheleia-body" spacing="spacing-0">
                                        {winterWheel.name}
                                    </Text>
                                    <Button
                                        variant="apheleia-text"
                                        onClick={() => {
                                            trackWinterWheelRemoveFromBasket();
                                            dispatch(setWinterWheel(null));
                                        }}
                                    >
                                        <CarConfigLabel label="carConfigOverviewRemove" />
                                    </Button>
                                </div>
                                <div>
                                    <Text variant="apheleia-body" spacing="spacing-0">
                                        <>
                                            +&nbsp;
                                            <Price
                                                price={winterWheel.price}
                                                forceCashPrice={!showAccessoriesRate(commonSettings, carConfigSettings)}
                                            />
                                        </>
                                    </Text>
                                </div>
                            </li>
                            {winterWheel.installTheWheels && (
                                <li className={styles.listitem}>
                                    <div>
                                        <Text variant="apheleia-body" spacing="spacing-0">
                                            <CarConfigLabel label="carConfigOverviewTileFittingCosts" />
                                        </Text>
                                        <Button
                                            variant="apheleia-text"
                                            onClick={() => {
                                                dispatch(setWinterWheel({ ...winterWheel, installTheWheels: false }));
                                                trackWinterWheelFitting(false);
                                            }}
                                        >
                                            <CarConfigLabel label="carConfigOverviewRemove" />
                                        </Button>
                                    </div>
                                    {winterWheel.installationCost && (
                                        <div>
                                            <Text variant="apheleia-body" spacing="spacing-0">
                                                +&nbsp;
                                                <Price price={winterWheel.installationCost} forceCashPrice />
                                            </Text>
                                        </div>
                                    )}
                                </li>
                            )}
                        </ul>
                    </>
                )}
            </div>
        </OverviewItemWrapper>
    );
};

export default memo(OverviewWheels);
